export const KTI_RULE_MODE = {
  ENABLED: 'ENABLED',
  DISABLED: 'DISABLED',
};

export const KTI_CONFIG_VALUE_NAMES = {
  ALLOWED: 'allowed',
  MAX_AMOUNT_EACH: 'max_amount_each',
};

export const KTI_DEFAULT_NAME = 'Default';
